import axios from 'axios';

// 1. Get latest messages list in DESC order with all users data
export async function getLatestMessages(queryParams = {}) {
  const searchText =
    queryParams.searchText ||
    (typeof queryParams.filter === 'string' ? queryParams.filter : '') ||
    queryParams.filter?.searchText ||
    queryParams.filter?.fromProfileId ||
    '';

  const params = {
    pageNumber: queryParams.pageNumber || 1,
    pageSize: queryParams.pageSize || 10,
    sortField: queryParams.sortField || 'CreatedOn',
    sortOrder: queryParams.sortOrder || 'desc',
    searchText: searchText,
  };

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/Message/GetLatestMessages`,
    params
  );
  return response.data;
}

// 2. Get chat thread messages between two profiles
export async function getChatMessages(
  fromMemberId = '',
  toMemberId = '',
  fromProfileId = '',
  toProfileId = ''
) {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/Message/Chat?fromMemberId=${fromMemberId || ''}&toMemberId=${toMemberId || ''}&fromProfileId=${fromProfileId || ''}&toProfileId=${toProfileId || ''}`
  );
  return response.data;
}

// 3. Send Chat Message API
export async function sendChatMessage(messagePayload) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/Message/Send`,
    messagePayload
  );
  return response.data;
}

// 4. Get list of distinct chat contacts for a user
export async function getUserContacts(memberId = '', profileId = '') {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/Message/UserContacts?memberId=${memberId || ''}&profileId=${profileId || ''}`
  );
  return response.data;
}

// Alias for table compatibility
export const getMessageList = getLatestMessages;

